<template>
  <div class="footer" :class="{'darkFooter': dark, 'staticFooter': isStatic}">
    <div class="footMain">
      <div class="footTxt">{{copyright}}</div>
      <!-- <div class="links">
        <img src="../assets/image/footer-linkedin.png" @click="linkWeb('https://www.linkedin.com/in/fay-yu-b3659038/')" alt="logo" class="logo-dark">
        <img src="../assets/image/footer-architizer.jpg" @click="linkWeb('https://architizer.com/firms/ftg-studio/')" alt="logo" class="logo-dark">
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'infoFooter',
  props: ['dark', 'isStatic'],
  data () {
    return {
      token: window.sessionStorage.getItem('token'),
      copyright: ''
    }
  },
  methods: {
    linkWeb(url){
      window.open(url, '_blank')
    }
  },
  created(){
    const that = this
    let Data = {
      // token: that.token
    }
    that.$api.getCopyrightInfo(Data).then(res => {
      if(res.rescode == 0){
        that.copyright = res.copyRight
      }
    }).catch(err => {});
  }
}
</script>

<style scoped lang="less">
  @import './component.less';
</style>



// WEBPACK FOOTER //
// src/components/infoFooter.vue